
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import FocusLock from 'react-focus-lock';
import { AppointmentSlot } from '@utils/api/aboboApiTypes';
import { FC } from 'react';
import { Button } from '@/components/ui/button';

type AppointmentSlotsProps = {
  onEscape?: () => void;
  onSelect?: (slot: AppointmentSlot) => void;
  slots?: AppointmentSlot[];
  data?: Date | null;
};

const AppointmentSlots:FC<AppointmentSlotsProps> = ({onEscape, onSelect, slots, data}) => {
  const { t } = useTranslation();

  return (
    <FocusLock disabled={!data}>
      <div 
        className="pt-4 grid grid-cols-2 md:grid-cols-3 gap-4" 
        onKeyDown={(event) => {
          if (onEscape && event.key === "Escape") {
            onEscape()
          }
        }}
        role="grid"
        tabIndex={0}
      >
        {slots?.map((slot, index) => {
          return (
            <div key={index} role="gridcell">
              <Button
                className="w-full"
                type="button"
                aria-label={`Select ${slot.displayTime || format(new Date(slot.time), 'p')}`}
                value={slot.time}
                onClick={() => onSelect && onSelect(slot)}
              >
                { format(new Date(slot.time), 'p') }
              </Button>
            </div>
          )
        })}
      </div>
        {slots?.length === 0 && (
          <p>
            {t('booking.noAppointments')}
          </p>
        )}
    </FocusLock>
  )
};

export default AppointmentSlots;